import React, { useState, useEffect } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

function ToggleTabs(toggleState, categoryNames) {
  const [currentFiveCategories, setCurrentFiveCategories] = useState([]); // display the first five categories from S3
  const [currentIndex, setCurrentIndex] = useState(0); // Get the index of the current category for the slider functionality
  const [activeDotIndex, setActiveDotIndex] = useState(0); // Track the active dot index

  useEffect(() => {
    const startIndex = currentIndex;
    const endIndex = startIndex + 5;
    const newVisibleCategories = categoryNames.slice(startIndex, endIndex);
    setCurrentFiveCategories(newVisibleCategories);
  }, [currentIndex, categoryNames]);

  const previousCategory = () => {
    const previousIndex = currentIndex - 1;
    const dotIndex = Math.floor(previousIndex / 5);

    console.log("previousIndex:", previousIndex);
    console.log("dotIndex:", dotIndex);

    if (previousIndex >= 0) {
      setActiveDotIndex(dotIndex);
      const previousCategories = categoryNames.slice(
        previousIndex,
        previousIndex + 5
      );
      setCurrentFiveCategories(previousCategories);
      setCurrentIndex(previousIndex);
    }
  };

  const nextCategory = () => {
    const nextIndex = currentIndex + 1;
    const isMultipleOfFive = nextIndex % 5 === 0;

    if (
      nextIndex < categoryNames.length ||
      (nextIndex === categoryNames.length && !isMultipleOfFive)
    ) {
      let dotIndex = isMultipleOfFive
        ? activeDotIndex + 1
        : Math.floor(nextIndex / 5);

      if (nextIndex === categoryNames.length - 5) {
        dotIndex = activeDotIndex + 1;
      }

      setActiveDotIndex(dotIndex);
      const nextCategories = categoryNames.slice(nextIndex, nextIndex + 5);
      setCurrentFiveCategories(nextCategories);
      setCurrentIndex(nextIndex);
    }
  };

  const handleSliderDotClick = (dotIndex) => {
    const lastDotIndex = Math.ceil(categoryNames.length / 5) - 1;

    if (dotIndex === lastDotIndex) {
      // 5 are always shown
      const newCurrentCategories = categoryNames.slice(-5);
      setCurrentFiveCategories(newCurrentCategories);
      setCurrentIndex(categoryNames.length - 5);
    } else {
      const newCurrentIndex = dotIndex * 5;
      const newCurrentCategories = categoryNames.slice(
        newCurrentIndex,
        newCurrentIndex + 5
      );

      setCurrentFiveCategories(newCurrentCategories);
      setCurrentIndex(newCurrentIndex);
    }

    setActiveDotIndex(dotIndex);
  };

  const tabs = (toggleTab) => {
    return (
      <div className="bloc-tabs-topic">
        <div className="bloc">
          {categoryNames.length > 5 && (
            <KeyboardArrowLeftIcon
              style={{
                fontSize: "2rem",
                color: currentIndex !== 0 ? "#FF931E" : undefined,
              }}
              className="left-arrow"
              onClick={currentIndex !== 0 ? previousCategory : undefined}
            />
          )}
          {currentFiveCategories.map((category) => (
            <div
              key={category}
              className={`tabs-topic ${
                toggleState === category ? "active-tabs-topic" : ""
              }`}
              onClick={() => toggleTab(category)}
            >
              <p>{category}</p>
            </div>
          ))}
          {categoryNames.length > 5 && (
            <div className="dot-container">
              {[...Array(Math.ceil(categoryNames.length / 5))].map(
                (item, index) => (
                  <div
                    className={`slider-dots ${
                      index === activeDotIndex ? "active-dot" : ""
                    }`}
                    key={index}
                    onClick={() => handleSliderDotClick(index)}
                  ></div>
                )
              )}
            </div>
          )}
          {categoryNames.length > 5 && (
            <>
              {currentIndex === categoryNames.length - 5 ? (
                <KeyboardArrowRightIcon
                  style={{ fontSize: "2rem", color: "#d3d3d3" }}
                  className="right-arrow"
                />
              ) : (
                <KeyboardArrowRightIcon
                  style={{ fontSize: "2rem" }}
                  className="right-arrow"
                  onClick={nextCategory}
                />
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  return { tabs };
}

export default ToggleTabs;
